import http from "../../helpers/http";
import * as helpers from "../../helpers/helpers";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
  FETCH_QUESTION_ARTICLE_CONTENT,
  FETCH_QUESTION_ARTICLE_CONTENT_SUCCESS,
  FETCH_QUESTION_ARTICLE_CONTENT_FAILED
} from "./actionTypes";

export const fetchQuestionArticle = (post) => (dispatch) => {
  dispatch({
    type: FETCH_QUESTION_ARTICLE_CONTENT,
    payload: null
  });
  http
    .post("question-article", helpers.doObjToFormData(post))
    .then(({ data }) => {
      dispatch({
        type: FETCH_QUESTION_ARTICLE_CONTENT_SUCCESS,
        payload: data
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_QUESTION_ARTICLE_CONTENT_FAILED,
        payload: error
      });
    });
};
